<button
  mat-icon-button
  (click)="onToggleFavourite()"
  [matTooltip]="isFavourite ? 'Unfavourite' : 'Favourite'"
  matTooltipPosition="above"
  color="error"
>
  <mat-icon>{{ isFavourite ? 'favorite' : 'favorite_border' }}</mat-icon>
</button>
